import {
  SVG,
  UserTierTypes,
  getTierLabel,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import DiamondEliteIcon from 'assets/TierLevelIcons/diamond-elite.svg';
import DiamondPlusIcon from 'assets/TierLevelIcons/diamond-plus.svg';
import DiamondIcon from 'assets/TierLevelIcons/diamond.svg';
import GoldIcon from 'assets/TierLevelIcons/gold.svg';
import PlatinumIcon from 'assets/TierLevelIcons/platinum.svg';
import SevenStarsIcon from 'assets/TierLevelIcons/seven-stars.svg';
import {Text, View} from 'native-base';
import React from 'react';
import FA5ProIcon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

export interface TierBadgeProps {
  tier?: UserTierTypes; // Optional to handle loading state before API returns data
  isGiftedTier: boolean;
}

const TierBadge: React.FC<TierBadgeProps> = ({tier, isGiftedTier}) => {
  const theme = useTheme();
  const {tierColors, white} = theme.colors;
  const isWeb = useIsWeb();

  // Don't render if tier data hasn't loaded yet or tier is not supported
  if (!tier || !tierColors[tier]) {
    return null;
  }

  const tierSummaryBadge = tierColors[tier].summaryBadge;
  const tierLabel = getTierLabel(tier);

  const TIER_ICON_MAP = {
    [UserTierTypes.GOLD]: GoldIcon,
    [UserTierTypes.PLATINUM]: PlatinumIcon,
    [UserTierTypes.DIAMOND]: DiamondIcon,
    [UserTierTypes.DIAMOND_PLUS]: DiamondPlusIcon,
    [UserTierTypes.DIAMOND_PLUS_LEGACY]: DiamondPlusIcon,
    [UserTierTypes.DIAMOND_ELITE]: DiamondEliteIcon,
    [UserTierTypes.DIAMOND_ELITE_LEGACY]: DiamondEliteIcon,
    [UserTierTypes.SEVEN_STARS]: SevenStarsIcon,
  };

  const badgeProperties = {
    bgColor: tierSummaryBadge.bgColor,
    textColor: tierSummaryBadge.textColor,
    textLabel: tierLabel,
    icon: TIER_ICON_MAP[tier] || GoldIcon, // Fallback to Gold icon if tier not found
  };

  return (
    <View flexDirection="row" alignItems="center">
      {isGiftedTier ? (
        <View
          backgroundColor="#ACB0B3"
          width="24px"
          height="24px"
          borderRadius="16px"
          alignItems="center"
          justifyContent="center"
          zIndex={2}>
          <FA5ProIcon name="gift" size={13} color={white} solid />
        </View>
      ) : (
        <View
          borderRadius="24px"
          backgroundColor={badgeProperties.bgColor}
          zIndex={2}>
          <SVG source={badgeProperties.icon} width={24} height={24} />
        </View>
      )}
      <View
        paddingLeft="20px"
        marginLeft="-12px"
        paddingRight="10px"
        height="24px"
        backgroundColor={badgeProperties.bgColor}
        borderRightRadius="16px"
        justifyContent="center"
        alignItems="center"
        zIndex={1}>
        <Text
          fontFamily="body"
          fontWeight="bold"
          fontSize="9px"
          lineHeight={isWeb ? '9px' : undefined}
          letterSpacing="1px"
          color={badgeProperties.textColor}
          textTransform="uppercase">
          {badgeProperties.textLabel}
        </Text>
      </View>
    </View>
  );
};

export default TierBadge;
